/* ridegrip.js v3.2 — smooth */
(function () {
  if (window.__rgInit) return; window.__rgInit = true;
  var pad = function (n) { return String(n).padStart(2, '0'); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Timers */
  var timers = [].slice.call(document.querySelectorAll('[data-rg-timer]'));
  function hideTimer(el) { var w = el.closest('[data-rg-timer-wrap]'); (w || el).style.display = 'none'; }
  function tick() {
    timers.forEach(function (el) {
      var end = new Date(el.getAttribute('data-end')).getTime();
      var diff = isNaN(end) ? 0 : Math.max(0, end - Date.now());
      if (!diff) { hideTimer(el); return; }
      var s = Math.floor(diff / 1000);
      var v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      for (var k in v) { var n = el.querySelector('[data-u="' + k + '"]'); if (n && n.textContent !== pad(v[k])) n.textContent = pad(v[k]); }
    });
  }
  if (timers.length) { tick(); setInterval(tick, 1000); }

  document.querySelectorAll('[data-rg-ship]').forEach(function (el) {
    var fmt = function (d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); };
    var add = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d; };
    var a = +el.dataset.shipMin || 1, b = +el.dataset.shipMax || 3, c = +el.dataset.delMin || 7, e = +el.dataset.delMax || 12;
    var set = function (k, v) { var n = el.querySelector('[data-d="' + k + '"]'); if (n) n.textContent = v; };
    set('order', fmt(new Date())); set('ship', fmt(add(a)) + '–' + fmt(add(b)).replace(/^[A-Za-z]+ /, '')); set('deliver', fmt(add(c)) + '–' + fmt(add(e)).replace(/^[A-Za-z]+ /, ''));
  });

  /* Gallery: native scroll-snap swipe, synced thumbs + counter */
  document.querySelectorAll('[data-rg-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-rg-track]'); if (!track) return;
    var slides = track.children, thumbs = g.querySelectorAll('[data-rg-thumb]'), count = g.querySelector('[data-rg-count]'), strip = g.querySelector('.rg-thumbs');
    var cur = -1, target = null;
    var idx = function () { return Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / Math.max(1, track.clientWidth)))); };
    function setActive(i) {
      if (i === cur) return;
      cur = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      if (strip && thumbs[i]) strip.scrollTo({ left: thumbs[i].offsetLeft - strip.offsetLeft - strip.clientWidth / 2 + thumbs[i].clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      target = i;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      setActive(i);
    }
    track.addEventListener('scroll', function () {
      var i = idx();
      if (target !== null) { if (i === target) target = null; else return; }
      setActive(i);
    }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var p = g.querySelector('[data-rg-prev]'), n = g.querySelector('[data-rg-next]');
    if (p) p.addEventListener('click', function () { go((target !== null ? target : idx()) - 1); });
    if (n) n.addEventListener('click', function () { go((target !== null ? target : idx()) + 1); });
    track.addEventListener('pointerdown', function () { target = null; [].forEach.call(track.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; }); }, { passive: true });
    setActive(idx());
  });

  /* Bundles */
  document.querySelectorAll('[data-rg-bundles]').forEach(function (wrap) {
    var form = document.getElementById(wrap.getAttribute('data-form'));
    var qty = form ? form.querySelector('[name="quantity"]') : null;
    var totals = document.querySelectorAll('[data-rg-total]');
    function sync(animate) {
      var picked = wrap.querySelector('input:checked'); if (!picked) return;
      wrap.querySelectorAll('.rg-bundle').forEach(function (b) { b.classList.toggle('is-active', b.contains(picked)); });
      if (qty) qty.value = picked.value;
      totals.forEach(function (t) {
        if (t.textContent === picked.getAttribute('data-total')) return;
        t.textContent = picked.getAttribute('data-total');
        if (animate && !reduce) { t.classList.remove('rg-pop'); void t.offsetWidth; t.classList.add('rg-pop'); }
      });
      document.querySelectorAll('[data-rg-atc]').forEach(function (b) { b.setAttribute('data-qty', picked.value); });
    }
    wrap.addEventListener('change', function () { sync(true); }); sync(false);
  });

  /* FAQ: smooth height animation, text stays white */
  document.querySelectorAll('.rg-acc details').forEach(function (d) {
    var s = d.querySelector('summary'), b = d.querySelector('.rg-acc__body');
    if (!s || !b || !b.animate || reduce) return;
    var anim = null;
    s.addEventListener('click', function (e) {
      e.preventDefault();
      if (anim) anim.cancel();
      var opening = !d.open;
      if (opening) d.open = true;
      var h = b.scrollHeight;
      anim = b.animate(opening ? [{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }] : [{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: opening ? 320 : 260, easing: 'cubic-bezier(.2,.8,.2,1)' });
      anim.onfinish = function () { if (!opening) d.open = false; anim = null; };
      s.blur();
    });
  });

  /* Reveal on scroll (only below the fold, so nothing flickers) */
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    var vh = window.innerHeight;
    document.querySelectorAll('.rg-section .rg-h2, .rg-grid3__item, .rg-table, .rg-table__cta, .rg-review, .rg-split__media, .rg-split__text, .rg-faq .rg-acc, .rg-final .rg-container, .rg-video').forEach(function (el, i) {
      if (el.getBoundingClientRect().top < vh) return;
      el.classList.add('rg-reveal');
      if (el.classList.contains('rg-grid3__item') || el.classList.contains('rg-review')) el.style.transitionDelay = ((i % 3) * 80) + 'ms';
      io.observe(el);
    });
  }

  /* Add to cart -> custom drawer */
  function addToCart(id, qty, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] }) })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        if (btn) btn.classList.remove('is-loading');
        if (window.RGCart) { window.RGCart.open(); } else { window.location.href = root + 'cart'; }
      })
      .catch(function () { window.location.href = root + 'cart'; });
  }
  document.querySelectorAll('form[data-rg-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = f.querySelector('[name="quantity"]');
      addToCart(f.querySelector('[name="id"]').value, q ? parseInt(q.value, 10) || 1 : 1, f.querySelector('[type="submit"]'));
    });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rg-atc]'); if (!b) return;
    e.preventDefault();
    if (b.hasAttribute('data-scroll')) { var t = document.getElementById('rg-buy'); if (t) { t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); return; } }
    addToCart(b.getAttribute('data-variant-id'), parseInt(b.getAttribute('data-qty'), 10) || 1, b);
  });

  /* Sticky mobile bar */
  var sticky = document.querySelector('[data-rg-sticky]'), buy = document.querySelector('[data-rg-buyzone]');
  if (sticky && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { var e = en[0]; sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(buy);
  }
})();
